import React from 'react';
import { t } from 'ttag';
import { Button, ButtonProps } from 'antd';

import useTranslation from '../../hooks/useTranslation';
import Layout from './Layout';

interface Props {
  scoped?: boolean;
  previousHref?: string;
  customButton?: ButtonProps & { text: string };
}

const HTTP500 = ({ scoped = false, previousHref = '/', customButton = null }: Props) => {
  useTranslation();
  return (
    <Layout
      scoped={scoped}
      title={t`Sorry, something went wrong`}
      body={t`We've encountered an issue. Please reload or try again later.`}
      support={false}
    >
      <Button type={scoped ? 'default' : 'primary'} onClick={() => window.location.reload()}>
        {t`Reload`}
      </Button>
      {!scoped && (
        <Button type="default" onClick={() => window.location.replace(previousHref)}>
          {t`Return to Homepage`}
        </Button>
      )}
      {customButton && (
        <Button type="default" onClick={customButton.onClick}>
          {customButton.text}
        </Button>
      )}
    </Layout>
  );
};

export default HTTP500;
